import { z } from 'zod';
import { journalLineSchema } from './schemas.js';

export const recurringTemplateSchema = z.object({
  name: z.string().min(1).max(120),
  frequency: z.enum(['monthly', 'weekly']),
  dayOfMonth: z.number().int().min(1).max(28).optional(),
  weekday: z.number().int().min(0).max(6).optional(),
  memo: z.string().max(500).optional(),
  lines: z.array(journalLineSchema).min(1),
  active: z.boolean().default(true),
  nextRunDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/)
});

export type RecurringTemplate = z.infer<typeof recurringTemplateSchema>;

export function advanceRecurringDate(
  frequency: 'monthly' | 'weekly',
  from: string,
  dayOfMonth?: number
): string {
  const d = new Date(`${from}T12:00:00Z`);
  if (frequency === 'weekly') {
    d.setUTCDate(d.getUTCDate() + 7);
    return d.toISOString().slice(0, 10);
  }
  const next = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, dayOfMonth ?? d.getUTCDate()));
  return next.toISOString().slice(0, 10);
}
